




























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IRankUser } from "@/types";
import MyTitle from "@/components/Title.vue";

function limitFrequency(timeout = 20) {
  return function(target: any, key: any, descriptor: any) {
    const oldValue = descriptor.value;
    let timer: any = null;
    descriptor.value = function() {
      clearTimeout(timer);
      timer = setTimeout(() => {
        oldValue.apply(this, arguments);
      }, timeout);
    };
    return descriptor;
  };
}

@Component({
  components: {
    MyTitle
  }
})
export default class UserTable extends Vue {
  @Prop({ type: String }) title?: string;
  @Prop({ type: Array, required: true }) rankUsers!: IRankUser[];
  @Prop({ type: String, default: "暂无数据" }) emptyTips?: string;
  @Prop({ type: Boolean, default: true }) hasQa!: boolean;
  @Prop({ type: Boolean, default: false }) isCaizhiActivity!: boolean;
  @Prop({ type: Boolean }) loading!: boolean;
  @Prop({ type: Boolean, default: () => false }) isActPage!: boolean;

  @limitFrequency(20)
  onScroll(e: any) {
    if (this.isActPage) return;
    if (
      e.target.scrollTop + e.target.clientHeight >=
      e.target.scrollHeight - 100
    ) {
      this.$emit("fetchData");
    }
  }
}
